module.exports = __webpack_public_path__ + "static/media/storage.48ddf78c.png";